import selecionaEmpresa from "../login/selecionaEmpresa";
import { getAllowedMenus } from "../services/auth/api";
import MenuNavegacaoBase from "./MenuNavegacaoBase";

/**
 * Layout global do login de cliente. Todo o comportamento está em
 * MenuNavegacaoBase; aqui ficam só as diferenças em relação ao embarcador.
 */
export default class MenuNavegacao extends MenuNavegacaoBase {
    /**
     * @param {string} empresaLogado
     * @param {{CAB_CODIGO: number, CAB_RAZAO: string}[]} filiaisLogado
     */
    constructor(empresaLogado, filiaisLogado) {
        super(empresaLogado, filiaisLogado, "Trocar de Empresa/Filial");
    }

    carregarMenusPermitidos() {
        return getAllowedMenus();
    }

    /**
     * Só o login de cliente admite as telas internas ("Motoristas tecnologia" e
     * "Serviços Jornada"). Se o usuário é interno é decidido em montarItensMenu;
     * aqui a resposta é sobre o tipo de login, não sobre o usuário.
     */
    incluiTelasInternas() {
        return true;
    }

    abreTelaInicio() {
        return true;
    }

    reabrirSelecaoDeContexto() {
        new selecionaEmpresa();
    }
}
